export const getReferralPrice = () => `${process.env.NEXT_PUBLIC_REFERRAL_DISCOUNT} ${process.env.NEXT_PUBLIC_CURRENCY}`
